import React, { useState, useEffect } from "react";
import { apiCall_domain } from "../api";
import "../../style/home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import axios from "axios";
import Header from "../header";
import Categories from "./Categories";
import AmazingSections from "./AmazingSections";
import Spinner from "../Spinner/Spinner";
import PopularCars from "./PopularCars";
import PopularBrands from "../Products/PopularBrands";
import Banner from "./Banner";
import CustomerClub from "./CustomerClub";
import ProductSwpier from "./ProductSwiper";
import PopularProducts from "./PopularProducts";
import Support from "./Support";

import Carousel from "../homePage/Carousel";

const MainPage = (props) => {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);

  useEffect(() => {
    localStorage.setItem("isLimited", "");
    localStorage.setItem("price_from", "");
    localStorage.setItem("price_To", "");
    localStorage.setItem("stock", "");
    localStorage.setItem("data", "");
    localStorage.setItem("dataMyCar", "");
    localStorage.setItem("myCarName", "");
    localStorage.setItem("hasInstall", "");
    localStorage.setItem("forceInstall", "");
    localStorage.setItem("sortChanged", "");
    localStorage.setItem("CategoryChildListId", "");
    localStorage.setItem("sendTicket", "");
    localStorage.setItem("MOveINGdeleveryType", "");

    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    const city_id = JSON.parse(localStorage.getItem("splash"))?.customer_info
      ?.city?.id;

    axios
      .get(`${apiCall_domain}/customer/index?city_id=${city_id}`, {
        headers: Headers,
      })
      .then((res) => {
        setData(res.data);
        setLoading(false);
      });
  }, []);

  const {
    special_section,
    categories,
    popular_cars,
    brands: dataBrands,
    newItems,
    popularItems,
    index_cycle_gifts,
    check_last_spin,
    index_image,
    top_tag,
  } = data;

  return loading ? (
    <Spinner />
  ) : (
    <React.Fragment>
      <Header
        top_tag={top_tag}
        showSearchBar={true}
        isMainPage={true}
        showBasket={true}
        goBackUrl={props.history.goBack}
      />
      <div className="index_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        {/* <IntroSliders Sliders={sliders} /> */}

        <Categories data={categories} />

        <AmazingSections
          link="/section/golden"
          data={special_section.golden.items}
          name={special_section?.golden?.name[0]}
          img={
            index_image.find(
              (img) => img.name === "golden_sales_responsive_image",
            )?.full_url
          }
        />
        <Carousel wheel={index_cycle_gifts} check_last_spin={check_last_spin} />
        <AmazingSections
          link="/section/amazing"
          img={
            index_image.find(
              (img) => img.name === "special_sales_responsive_image",
            )?.full_url
          }
          data={special_section.amazing.items}
        />

        <ProductSwpier data={newItems} />
        {data.lottery &&
        data.lottery.length &&
        data.lottery.find((l) => !l.is_expired_time) ? (
          <CustomerClub timer={data.lottery.find((l) => !l.is_expired_time)} />
        ) : (
          ""
        )}
        <div className="head">
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            spaceBetween={24}
          >
            <SwiperSlide>
              <Banner img={4} />{" "}
            </SwiperSlide>
            <SwiperSlide>
              <Banner img={3} />
            </SwiperSlide>
          </Swiper>
        </div>

        {/* <Link to="/Search" className="searchBtn">
          <div>
            <span>محصولات مناسب ماشین من را پیدا کن</span>
          </div>
          <img alt="" src="/public/assets/bluecar.svg" />
        </Link> */}
        {/* <SuggestedCategories data={special_tags} /> */}
        <PopularCars data={popular_cars} />
        {/* <NewSpecialSale data={special_section.amazing.items} /> */}
        {/* <ProductSwpier data={newItems} content={"newProducts"} /> */}
        <PopularProducts popularItems={popularItems} />
        {/* <Weblog data={blog_posts} /> */}
        <PopularBrands data={dataBrands} />
        {/* <Services /> */}
        <Support />
      </div>
    </React.Fragment>
  );
};

export default MainPage;
